import useStyles from "./styles/community";
import { withTranslation } from "../../i18n";
import { Hidden, useTheme } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const desktopCommunity = "/static/new-landing-page/community/desktop_community.webp";
const mobileCommunity = "/static/new-landing-page/community/mobile_community.webp";


const Community = ({ t, i18n }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery('(min-width:1400px)');

    function renderText() {
        if (i18n.language === "id") {
            return (
                <span>Bergabunglah dengan komunitas ratusan ribu orang yang berhasil mencapai goal mereka</span>
            )
        }
        return (
            <span>Join the community of millions crushing<br />their goals with Myfitsociety</span>
        )
    }
    return (
        <div className={classes.root}>
            {renderText()}
            <div className={classes.ctnImage}>
                <picture>
                    <source media="(min-width: 600px)" srcSet={desktopCommunity} />
                    <img src={mobileCommunity} srcSet="/static/new-landing-page/community/mobile_community_750w.webp 750w, /static/new-landing-page/community/mobile_community.webp 900w" sizes="100vw" alt="community" loading="lazy" />
                </picture>
            </div>
        </div>
    );
};

export default withTranslation(["myfitsociety"])(Community);